<script>
import PasswordField from '@phoenix/mixins/components/form/fields/PasswordField';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [PasswordField],

  inject: ['onPasswordValidation', 'onFieldFocused'],

  setup(props) {
    return useField(props);
  },

  data() {
    return {
      passwordRules: window.Phoenix.config.PASSWORD_RULES,
      specialCharsConfig:
        getFeatureFlag(FEATURE_FLAG.GEMINI_KR) || getFeatureFlag(FEATURE_FLAG.GEMINI_CN) ? 'gemini' : 'default',
    };
  },

  methods: {
    onFocus() {
      this.onFieldFocused();
    },

    validatePassword() {
      const minLength = this.field.value?.length >= this.passwordRules.minChars;
      let specialChars = !new RegExp(this.passwordRules.regex.specialChars[this.specialCharsConfig].optional).test(
        this.field.value,
      );

      if (this.passwordRules.isAllRegexObligatory === true) {
        specialChars =
          specialChars &&
          new RegExp(this.passwordRules.regex.specialChars[this.specialCharsConfig].mandatory).test(this.field.value);
      }

      const englishUppercaseCharacters = new RegExp(this.passwordRules.regex.uppercase).test(this.field.value);
      const base10Digit = new RegExp(this.passwordRules.regex.digit).test(this.field.value);
      const noConsecutiveCharacters = !new RegExp(this.passwordRules.regex.nonConsecutive).test(this.field.value);

      this.onPasswordValidation({
        minLength,
        specialChars,
        englishUppercaseCharacters,
        base10Digit,
        noConsecutiveCharacters,
      });
    },
  },
};
</script>

<template>
  <text-field v-model="value" :attrs="fieldAttrs" :should-validate="false" @focus="onFocus" @keyup="validatePassword" />
</template>
